import { createNcpApiStore } from '@/api'
import { getDateFormat } from '@/utils/dateUtils'
import { formatCurrency } from '../../utils/StringUtils'
import { loadTGScript, showAlertWithOneButton } from '@/utils/utils'
import router from '@/router'
import { calBuyConfirmReward } from '@/utils/reward'

const apiStore = createNcpApiStore([
  {
    action: '_fetchProduct',
    property: 'product',
    path: 'products/{mallProductNo}',
    pathParams: ['mallProductNo'],
    method: 'get'
  },
  {
    action: '_fetchProductOptions',
    property: 'options',
    path: 'products/{mallProductNo}/options',
    pathParams: ['mallProductNo'],
    method: 'get'
  },
  {
    action: '_fetchOptionsMainImgs',
    property: 'optionsMainImgs',
    path: 'products/{productNo}/options/images?imageCondition=ONLY_MAIN',
    pathParams: ['productNo'],
    method: 'get'
  },
  {
    action: '_fetchOptionsImgs',
    property: 'optionImgs',
    path: 'products/{productNo}/options/{optionNo}/images',
    pathParams: ['productNo', 'optionNo'],
    method: 'get',
    onSuccess (state, payload) {
      if (payload.data && payload.data.length > 0) {
        const item = {
          optionNo: payload.data[0].optionNo,
          imgs: payload.data.map(imgTemp => imgTemp.imageUrl)
        }
        state.optionImgs.push(item)
      }
    }
  },
  {
    action: '_getFavoriteKeywords',
    property: 'favoriteKeywords',
    path: 'products/favoriteKeywords?size=10',
    method: 'get'
  }
])

export default {
  namespaced: true,
  mixins: [apiStore],
  state: {
    dateInfo: false,
    optionImgs: [],
    selectedOption: '',
    detailBottomOpen: false,
    viewPopOpen: false,
    bodyScrollTop: 0,
    mainBottomOptionOpen: false
  },
  actions: {
    async fetchProduct ({ state, dispatch, commit, rootState }, product) {
      const mallProductNo = product.productNo
      const preview = product.preview === 'true'
      if (state.product === null || (state.product && state.product.baseInfo && state.product.baseInfo.imageUrls === null)) {
        await dispatch('_fetchProduct', { params: { mallProductNo, preview } }).catch((e) => {
          if (e.data.code === 'E0005') {
            showAlertWithOneButton(this, e.data.message)
            window.location.href = '/'
          } else if (e.code === 'NETWORK_ERROR') {
            if (window.location.pathname.indexOf('/product/') > -1) {
              setTimeout(() => {
                window.location.reload()
              }, 3000)
            }
          }
        })
      }
      if (router.currentRoute._value.name === 'ProductDetail' && product.isAce && state.product) {
        let salePrice = state.product.price.salePrice - state.product.price.immediateDiscountAmt - state.product.price.additionDiscountAmt
        let category = ''
        if (state.product.categories.length) {
          category = state.product.categories[0].fullCategoryLabel.split('>')
        }
        // acecount
        window._AceTM = (window._AceTM || {})
        window._AceTM.Product = {
          pCode: state.product.baseInfo.productNo.toString(), // 제품아이디(필수)
          pName: state.product.baseInfo.productName, // 제품이름(필수)
          pPrice: salePrice, // 판매가(필수)
          pCategory: category[category.length - 1], // 제품 카테고리명(선택)
          pImageURl: state.product.baseInfo.imageUrls[0],
          pLink: window.location.href, // 제품상세페이지 주소(필수)
          oItem: []
        }
        // setTimeout(() => {
        //   // more
        //   let evtCate = state.product.categories[0].fullCategoryLabel.split('>')
        //   let evtData = {
        //     evt: 'view',
        //     p_no: state.product.baseInfo.productNo.toString(),
        //     p_name: state.product.baseInfo.productName,
        //     price: salePrice.toString(),
        //     regular_price: state.product.price.salePrice.toString(),
        //     thumb: encodeURI(state.product.baseInfo.imageUrls[0]),
        //     p_url: window.location.href,
        //     cate1: evtCate[0] || '',
        //     cate2: evtCate[1] || '',
        //     cate3: evtCate[2] || '',
        //     soldout: state.product.status.soldout ? '1' : '0'
        //   }
        //   window.mcroPushEvent(evtData)
        // }, 500)
        // TG
        loadTGScript(window._AceTM.Product, 'product')
      }
      commit('PRODUCT_IMAGE')
      if (state.product && state.product.baseInfo && state.product.baseInfo.optionImageViewable) {
        await dispatch('_fetchOptionsMainImgs', { params: { productNo: mallProductNo } })
        if (state.optionsMainImgs) {
          state.optionsMainImgs.forEach(option => {
            if (!state.optionImgs.some(obj => obj.optionNo === option.optionNo)) {
              dispatch('_fetchOptionsImgs', { params: { productNo: mallProductNo, optionNo: option.optionNo } })
            }
          })
        }
      }
    },
    fetchProductOptions ({ state, dispatch, commit, rootState }, mallProductNo) {
      return dispatch('_fetchProductOptions', { params: { mallProductNo } })
    },
    async refreshProduct ({ state, dispatch, commit, rootState }, mallProductNo) {
      return dispatch('_fetchProduct', { params: { mallProductNo } })
    },
    async refreshOptions ({ state, dispatch, commit, rootState }, mallProductNo) {
      return dispatch('_fetchProductOptions', { params: { mallProductNo } })
    }
  },
  mutations: {
    CLEARPRODUCT (state) {
      state.product = null
    },
    CHANGELIKED (state) {
      if (state.product) {
        state.product.liked = !state.product.liked
      }
    },
    MODIFY_TIME (state) {
      if (state.dateInfo) {
        state.dateInfo = false
      }
    },
    PRODUCT_IMAGE (state) {
      if (state.product && state.product.baseInfo) {
        if (!state.product.baseInfo.imageUrls || state.product.baseInfo.imageUrls.length === 0) {
          state.product.baseInfo['defaultImages'] = 'default'
        }
      }
    },
    SELECT_OPTION (state, optionNo) {
      state.selectedOption = optionNo
    },
    SET_VIEW_POP_OPEN (state, openFlg) {
      state.viewPopOpen = openFlg
    },
    SET_DETAIL_BOTTOM_OPEN (state, openFlg) {
      state.detailBottomOpen = openFlg
    },
    SET_PRODUCTLIST_BOTTOM_OPEN (state, openFlg) {
      state.detailBottomOpen = openFlg
    },
    SET_BODY_SCROLL_TOP (state, bodyScrollTop) {
      state.bodyScrollTop = bodyScrollTop
    },
    CLEAR_OPTION_IMGS (state) {
      state.optionImgs = []
    },
    SET_MAIN_BOTTOM_OPTION_OPEN (state, openFlg) {
      state.mainBottomOptionOpen = openFlg
    }
  },
  getters: {
    displayOptions (state) {
      //  console.log(state)
      let dispOpt = []
      if (state.options && state.options.flatOptions && state.options.type === 'COMBINATION') {
        // 옵션별 예상 적립금 계산
        state.options.flatOptions.forEach((option) => {
          option.accumulationAmt = calBuyConfirmReward(new Date(), option.buyPrice, 1, { 
            salePrice: option.buyPrice,
            addPrice: 0,
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0 
          },{ 
            productCouponAmt: 0,
            cartCouponAmt: 0,
            accumulationAmt: 0
          }, option.productNo)
        })
        const flatOpts = state.options.flatOptions
        const values = flatOpts.map((item) => item.value)

        state.options.labels.forEach((lab, idx, arr) => {
          let optval = values.map((item) => item.split('|')[idx])
          optval = Array.from(new Set(optval))
          const obj = { label: lab, value: optval }
          dispOpt.push(obj)
        })
      }
      // if (state.options && state.options.flatOptions && (state.options.type === 'STANDARD' || state.options.type === 'DEFAULT')) {
      //   state.options.labels.forEach((lab, idx, arr) => {
      //     const obj = { label: lab, value: state.options.flatOptions }
      //     dispOpt.push(obj)
      //   })
      // }
      if (state.options && state.options.flatOptions && (state.options.type === 'STANDARD' || state.options.type === 'DEFAULT')) {
        dispOpt = [...state.options.flatOptions]
      }
      return dispOpt
    },
    optionInputsGetters (state) {
      let arr = []
      if (state.options && state.options.inputs) {
        arr = state.options.inputs.filter((optItem) => optItem.inputMatchingType === 'OPTION')
      }
      return arr
    },
    optionsTypeCOMBINATION (state) {
      if (state.options) {
        return state.options.type === 'COMBINATION'
      }
    },
    optionsTypeDEFAULT (state) {
      if (state.options) {
        return state.options.type === 'DEFAULT'
      }
    },
    optionsTypeSTANDARD (state) {
      if (state.options) {
        return state.options.type === 'STANDARD'
      }
    },
    productInputsGetters (state) {
      let arr = []
      if (state.options && state.options.inputs) {
        arr = state.options.inputs.filter((optItem) => optItem.inputMatchingType === 'PRODUCT')
      }
      return arr
    },
    productDetail (state) {
      if (state.product && state.product.baseInfo) {
        state.dateInfo = false
        let endDate = new Date(state.product.baseInfo.saleEndYmdt.replace(/-/g, '/'))
        let currentDate = new Date()
        if (endDate.getTime() - currentDate.getTime() < 86400000 * 30 && endDate.getTime() - currentDate.getTime() > 0) {
          let runTime = parseInt((endDate.getTime() - currentDate.getTime()) / 1000)
          let year = Math.floor(runTime / 86400 / 365)
          runTime = runTime % (86400 * 365)
          let month = Math.floor(runTime / 86400 / 30)
          runTime = runTime % (86400 * 30)
          let day = Math.floor(runTime / 86400)
          runTime = runTime % 86400
          let hour = Math.floor(runTime / 3600)
          runTime = runTime % 3600
          let minute = Math.floor(runTime / 60)
          let second = runTime % 60
          let dateStr = ''
          if (year !== 0) {
            dateStr = dateStr + year + '년 '
          }
          if (month !== 0) {
            dateStr = dateStr + month + '개월 '
          }
          if (day !== 0) {
            dateStr = dateStr + day + '일'
            state.product.baseInfo.getProDate = dateStr
          } else if (hour !== 0 || minute !== 0 || second !== 0) {
            state.dateInfo = true
          }
        }

        if (state.product.baseInfo.manufactureYmdt) {
          state.product.baseInfo.manufactureYmdt = getDateFormat(state.product.baseInfo.manufactureYmdt)
        }

        if (state.product.baseInfo.expirationYmdt) {
          state.product.baseInfo.expirationYmdt = getDateFormat(state.product.baseInfo.expirationYmdt) + ' 까지'
        }

        if (state.product.deliveryFee && state.product.deliveryFee.deliveryConditionType === 'FIXED_FEE') {
          state.product.deliveryFee.defaultDeliveryConditionLabel = state.product.deliveryFee.defaultDeliveryConditionLabel.replace('{{deliveryAmt}}', formatCurrency(state.product.deliveryFee.deliveryAmt))
        }
        if (state.product.baseInfo.stickerLabels && state.product.baseInfo.stickerLabels.length > 0) {
          const tempSticker = []
          if (state.product.baseInfo.stickerLabels.some(sticker => sticker === '기부천사')) {
            tempSticker.push('기부천사')
          }
          state.product['newStickers'] = tempSticker
        }
        return state.product
      }
    },
    productOptionsImgs (state) {
      if (state.optionImgs && state.optionsMainImgs && state.optionsMainImgs.length === state.optionImgs.length) {
        const productOptionsImgs = []
        state.optionsMainImgs.forEach(mainItem => {
          if (!mainItem.soldout) {
            productOptionsImgs.push(...state.optionImgs.filter(item => item.optionNo === mainItem.optionNo))
          }
        })
        return productOptionsImgs
      }
    }
  }
}
